import { Order } from 'src/app/models/configurators-2d/order';
import { CarpentryOrder } from 'src/app/models/configurators-2d/applications/carpentry/carpentry-order';

type CarpentryOrderLike = Order & {
  orderRefNumbers?: number[];
};

type CarpentryOrderState = {
  isLocked?: boolean;
  locked?: boolean;
  opportunityNumber?: number;
  orders?: CarpentryOrderLike[];
  orderRefNumbers?: number[];
  quotationRecords?: unknown[];
  products?: unknown[];
};

function hasOrderNumber(record: unknown): boolean {
  const orderNumber = (record as { orderNumber?: unknown })?.orderNumber;
  return typeof orderNumber === 'string' && orderNumber.trim().length > 0;
}

export function getLatestCarpentryOrder(configuration?: CarpentryOrderState): CarpentryOrderLike | undefined {
  return configuration?.orders
    ?.toSorted((a, b) => new Date(a.sendDate).getTime() - new Date(b.sendDate).getTime())
    .at(-1);
}

export function hasCarpentryComPlusOrder(configuration?: CarpentryOrderState): boolean {
  return (
    (configuration?.opportunityNumber != null && configuration.opportunityNumber !== 0) ||
    (configuration?.orders?.some(order => order.opportunityNumber != null && order.opportunityNumber !== 0) ?? false)
  );
}

export function hasCarpentrySapOrderNumber(configuration?: CarpentryOrderState): boolean {
  const records = configuration?.quotationRecords ?? configuration?.products ?? [];
  const hasRecordOrderNumber = records.some(hasOrderNumber);
  if (hasRecordOrderNumber) {
    return true;
  }

  const paidOrderRefNumbers = configuration?.orderRefNumbers ?? getLatestCarpentryOrder(configuration)?.orderRefNumbers;
  return (paidOrderRefNumbers?.length ?? 0) > 0;
}

export function isCarpentryWaitingForSapOrderNumber(configuration?: CarpentryOrderState): boolean {
  return hasCarpentryComPlusOrder(configuration) && !hasCarpentrySapOrderNumber(configuration);
}

export function isCarpentryLockedBySapOrderNumber(configuration?: CarpentryOrderState): boolean {
  return hasCarpentryComPlusOrder(configuration) && hasCarpentrySapOrderNumber(configuration);
}

export function isCarpentryProjectLocked(configuration?: CarpentryOrderState): boolean {
  return (
    configuration?.isLocked === true ||
    configuration?.locked === true ||
    isCarpentryLockedBySapOrderNumber(configuration)
  );
}
